import { Text } from "@/elements"
import { MetadataSectionContainer } from "./MetadataSectionContainer"
import clsx from "clsx"

interface Props {
  title: string
  text: string
  isEditing?: boolean
  onEditClick?: () => void
}

export const TextMetadataSection: React.FC<Props> = ({ title, text, onEditClick, isEditing }) => {
  return (
    <MetadataSectionContainer title={title}>
      <div
        className={clsx("mt-4", isEditing && "cursor-pointer rounded-sm bg-bg-2 p-1 hover:bg-bg-3")}
        onClick={() => {
          if (isEditing && onEditClick) {
            onEditClick()
          }
        }}>
        <Text className="whitespace-pre-wrap">{text}</Text>
      </div>
    </MetadataSectionContainer>
  )
}
